import { useMemo } from 'react'
import { useLocale } from '../useLocale'

const useRelativeDateFormatter = (locale?: string) => {
  const userLocale = useLocale()
  const actualLocale = useMemo(() => locale ?? userLocale, [locale, userLocale])

  return useMemo(() => {
    const rtf = new Intl.RelativeTimeFormat(actualLocale, { numeric: 'auto' })

    return (durationInDays: number) => rtf.format(durationInDays, 'days')
  }, [actualLocale])
}

export { useRelativeDateFormatter }
